import { useMemo, useCallback } from 'react'

import { isDateInThePast } from '../utils/DateUtils'


const useConfiguration = (query) => {
  const isDateElapsed = useCallback((date) => isDateInThePast(date, new Date()), [])

  const seoFallback = useMemo(() => query?.contentfulConfiguration?.seo, [query])

  return { configuration: { ...query?.contentfulConfiguration } ?? {}, isDateElapsed, seoFallback }
}

export default useConfiguration
